import React from "react";

export default function ControlsBar({
  search,
  onSearchChange,
  availFilter,
  onAvailFilterChange,
  onAdd,
}) {
  return (
    <div className="toolbar">
  <div className="toolbar-left">
    <input
      className="search"
      placeholder="Search items by name, category, subcategory…"
      value={search}
      onChange={(e)=>onSearchChange(e.target.value)}
    />
    <select
      className="filter-dropdown"
      value={availFilter}
      onChange={(e) => onAvailFilterChange(e.target.value)}
    >
      <option value="all">All</option>
      <option value="available">Available</option>
      <option value="unavailable">Unavailable</option>
    </select>
  </div>

  <div className="toolbar-right">
    <button className="menu-btn" onClick={onAdd}>Add Item</button>
  </div>
</div>

  );
}
